module.exports = __webpack_public_path__ + "static/media/Mr Yin Shi.77e7e14a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/Mr Yin Shi.jpg
// module id = 180
// module chunks = 0